import {
  Logotype,
  LogotypeBorder,
  LogotypeBurger,
  LogotypeIcon,
  LogotypeLink,
  LogotypeLinkContainer,
  ToggleBranchesButton,
} from "../styles";

interface LogotypeComponentProps {
  className?: string;
  toggleOpened: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  company?: Record<string, any> | null;
  toggleOpenedBranches: () => void;
  branchesTariffPerm: boolean;
}

const LogotypeComponent = ({
  className,
  toggleOpened,
  company = {},
  toggleOpenedBranches,
  branchesTariffPerm,
}: LogotypeComponentProps) => {
  return (
    <Logotype className={className}>
      <LogotypeLinkContainer>
        <LogotypeLink to='/'>Digital Cleaning</LogotypeLink>
        <LogotypeBurger onClick={toggleOpened}>
          <LogotypeIcon icon='mi-close' />
        </LogotypeBurger>
      </LogotypeLinkContainer>
      <ToggleBranchesButton
        onClick={toggleOpenedBranches}
        type='button'
        disabled={!branchesTariffPerm}>
        <LogotypeBorder style={{ padding: "8px 0" }}>
          <p>{company?.name || ""}</p>
        </LogotypeBorder>
        <LogotypeLinkContainer style={{ padding: "8px 0" }}>
          <p>{company?.address?.cityName || ""}</p>
        </LogotypeLinkContainer>
      </ToggleBranchesButton>
    </Logotype>
  );
};

export default LogotypeComponent;
